
import React, { PureComponent } from 'react';

class ModalFixed extends PureComponent {


    render() {
        return (
            <div data-backdrop="true"
                id={this.props.name}
                data-autofocus-first-input={String(!!this.props.autoFocusFirstInput)}
                className="modal modal_fixed modal_column modal_column-attention modal_column-flex fade modal-new modal-verification-new">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content js-form-wrapper">
                        <div className="modal-header">
                            {this.props.header}
                        </div>
                        {this.props.children}
                        {this.props.footer &&
                            <div className="modal-footer modal-footer_no-content">
                                {this.props.footer}
                            </div>
                        }
                        {/* todo: use errors with react
                            <div className="modal-errors has-danger"
                                 data-phone-required="{trans}L_PHONE_REQUIRED{/trans}"
                                 data-phone-valid-reg="{trans}L_PHONE_INVALID{/trans}">
                                <div className="modal-errors__content-box">
                                    <div className="modal-errors__content">
                                        <span className="ico ico-info-error"></span>
                                        <span className="js-error-text"></span>
                                        <button className="transparent-button ico-small-cross"></button>
                                    </div>
                                </div>
                            </div>
                         */}
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalFixed;